if (typeof window.com === 'undefined') window.com = new Object();
if (typeof window.com.parkside === 'undefined') window.com.parkside = new Object();
if (typeof window.com.parkside.abdeckleisten_renderer === 'undefined')
  window.com.parkside.abdeckleisten_renderer = new Object();

// constructor

window.com.parkside.abdeckleisten_renderer = function(canvas_id, parameter) {
  var t = this;
  jQuery(document).ready(function(e) {
    var defaults = {
      deckform: 'R',
      verlegerichtung: 'Q',
      deckwinkel: 0,
      verlegeabstand: 32,
      w1: 300,
      h1: 200,
      w2: 0,
      h2: 0,
      rw1: 5,
      rh1: 5,
      rw2: 5,
      rh2: 5,
      anzzeilen1: 20,
      anzzeilen2: 20,
      interaktiv: 32,
      paddingTop: 25,
      paddingLeft: 25,
    };
    if (typeof parameter === 'undefined') parameter = defaults;
    for (var param in defaults) {
      if (typeof parameter[param] === 'undefined') {
        parameter[param] = defaults[param];
      }
    }
    t.ready(canvas_id, parameter);
  });
};

com.parkside.abdeckleisten_renderer.prototype = {
  kappen: 0,
  leisten: 0,
  alleleisten: 0,
  ausgewaelteraender: {},

  ready: function(canvas_id, parameter) {
    var t = this;

    t.params = parameter;

    var minmeas = Math.min(t.params.w1, t.params.h1);
    t.params.interaktiv = Math.min(minmeas * 0.5, t.params.interaktiv);
    t.params.interaktiv2 = t.params.interaktiv * 0.5;

    t.canvas_id = canvas_id;
    t.canvas_holder = jQuery('#' + t.canvas_id);
    t.canvas_wrapper = t.canvas_holder.parent();

    t.params.paddingLeft = Math.ceil(350 - t.params.w1 - t.params.w2) * 0.5;
    t.params.paddingTop = Math.ceil(350 - t.params.h1 - t.params.h2) * 0.5;

    t.canvas = Raphael(canvas_id, 350, 350);

    t.markers = {};
    t.hoverMarkers = {};

    if (Raphael.type === 'VML') {
      t.params.deckwinkel = 0;
    }

    var splitt = jQuery('input[name=ausgewaelteraender]')
      .val()
      .toString()
      .split(',');
    for (var i = 0; i < splitt.length; ++i) {
      t.ausgewaelteraender[splitt[i]] = 1;
    }

    if (t.params.deckform == 'R') {
      t.initRectangle();
    } else {
      t.initLForm();
    }
  },

  drawRectangleSavedMarkers: function() {
    var t = this;
    for (var rand in t.ausgewaelteraender) {
      switch (rand) {
        case 'links':
          t.markers['links'] = t.drawMarker(t.params.paddingLeft, t.params.paddingTop, t.params.h1, 0);
          t.addQuantities('links', t.params.verlegerichtung, t.params.rh1, t.params.anzzeilen1);
          break;
        case 'rechts':
          t.markers['rechts'] = t.drawMarker(
            t.params.paddingLeft + t.params.w1,
            t.params.paddingTop + t.params.h1,
            t.params.h1,
            180
          );
          t.addQuantities('rechts', t.params.verlegerichtung, t.params.rh1, t.params.anzzeilen1);
          break;
        case 'oben':
          t.markers['oben'] = t.drawMarker(t.params.paddingLeft + t.params.w1, t.params.paddingTop, t.params.w1, 90);
          t.addQuantities('oben', t.params.verlegerichtung, t.params.rw1, t.params.anzzeilen1);
          break;
        case 'unten':
          t.markers['unten'] = t.drawMarker(t.params.paddingLeft, t.params.paddingTop + t.params.h1, t.params.w1, 270);
          t.addQuantities('unten', t.params.verlegerichtung, t.params.rw1, t.params.anzzeilen1);
          break;
      }
    }
    for (var i in t.interactives) {
      t.interactives[i].toFront();
    }
  },

  drawRectangleInteractives: function(w1, h1) {
    var t = this;
    var interactives = [];

    //// Oben
    interactives.push(
      t.canvas
        .rect(
          t.params.paddingLeft + t.params.interaktiv2,
          t.params.paddingTop - t.params.interaktiv2,
          w1 - t.params.interaktiv,
          t.params.interaktiv
        )
        .attr({ stroke: '#bdbcba', fill: '#ebebea', 'stroke-width': 1, opacity: 0, cursor: 'pointer' })
        .click(function() {
          /// oben
          if (typeof t.markers['oben'] !== 'undefined') {
            t.undrawMarker('oben');
            t.removeQuantities('oben', t.params.verlegerichtung, t.params.rw1, t.params.anzzeilen1);
          } else {
            t.markers['oben'] = t.drawMarker(t.params.paddingLeft + t.params.w1, t.params.paddingTop, t.params.w1, 90);
            t.addQuantities('oben', t.params.verlegerichtung, t.params.rw1, t.params.anzzeilen1);
          }
          for (var i in interactives) {
            interactives[i].toFront();
          }
        })
    );
    /// unten
    interactives.push(
      t.canvas
        .rect(
          t.params.paddingLeft + t.params.interaktiv2,
          t.params.paddingTop + h1 - t.params.interaktiv2,
          w1 - t.params.interaktiv,
          t.params.interaktiv
        )
        .attr({ stroke: '#bdbcba', fill: '#ebebea', 'stroke-width': 1, opacity: 0, cursor: 'pointer' })
        .click(function() {
          /// unten
          if (typeof t.markers['unten'] !== 'undefined') {
            t.undrawMarker('unten');
            t.removeQuantities('unten', t.params.verlegerichtung, t.params.rw1, t.params.anzzeilen1);
          } else {
            t.markers['unten'] = t.drawMarker(
              t.params.paddingLeft,
              t.params.paddingTop + t.params.h1,
              t.params.w1,
              270
            );
            t.addQuantities('unten', t.params.verlegerichtung, t.params.rw1, t.params.anzzeilen1);
          }
          for (var i in interactives) {
            interactives[i].toFront();
          }
        })
    );
    /// links
    interactives.push(
      t.canvas
        .rect(
          t.params.paddingLeft - t.params.interaktiv2,
          t.params.paddingTop + t.params.interaktiv2,
          t.params.interaktiv,
          h1 - t.params.interaktiv
        )
        .attr({ stroke: '#bdbcba', fill: '#ebebea', 'stroke-width': 1, opacity: 0, cursor: 'pointer' })
        .click(function() {
          if (typeof t.markers['links'] !== 'undefined') {
            t.undrawMarker('links');
            t.removeQuantities('links', t.params.verlegerichtung, t.params.rh1, t.params.anzzeilen1);
          } else {
            t.markers['links'] = t.drawMarker(t.params.paddingLeft, t.params.paddingTop, t.params.h1, 0);
            t.addQuantities('links', t.params.verlegerichtung, t.params.rh1, t.params.anzzeilen1);
          }

          for (var i in interactives) {
            interactives[i].toFront();
          }
        })
    );
    /// rechts
    interactives.push(
      t.canvas
        .rect(
          t.params.paddingLeft + w1 - t.params.interaktiv2,
          t.params.paddingTop + t.params.interaktiv2,
          t.params.interaktiv,
          h1 - t.params.interaktiv
        )
        .attr({ stroke: '#bdbcba', fill: '#ebebea', 'stroke-width': 1, opacity: 0, cursor: 'pointer' })
        .click(function() {
          /// rechts
          if (typeof t.markers['rechts'] !== 'undefined') {
            t.undrawMarker('rechts');
            t.removeQuantities('rechts', t.params.verlegerichtung, t.params.rh1, t.params.anzzeilen1);
          } else {
            t.markers['rechts'] = t.drawMarker(
              t.params.paddingLeft + t.params.w1,
              t.params.paddingTop + t.params.h1,
              t.params.h1,
              180
            );
            t.addQuantities('rechts', t.params.verlegerichtung, t.params.rh1, t.params.anzzeilen1);
          }
          for (var i in interactives) {
            interactives[i].toFront();
          }
        })
    );

    return interactives;
  },

  initRectangle: function() {
    var t = this;

    t.form = t.drawRectangle(t.params.w1, t.params.h1);
    t.lines = t.drawRectangleLines(t.params.w1, t.params.h1, t.params.verlegerichtung);
    t.measurements = t.drawRectangleMeasurements(t.params.w1, t.params.h1, t.params.rw1, t.params.rh1);
    t.interactives = t.drawRectangleInteractives(t.params.w1, t.params.h1);
    t.drawRectangleSavedMarkers();
  },

  drawRectangle: function(w, h) {
    var t = this;
    return t.canvas
      .path('M' + t.params.paddingLeft + ',' + t.params.paddingTop + 'v' + h + 'h' + w + 'v-' + h + 'Z')
      .attr({ stroke: '#bdbcba', fill: '#ebebea', 'stroke-width': 1 });
  },

  drawRectangleLines: function(w, h, verlegerichtung) {
    var t = this;
    var lines = [];
    if (verlegerichtung === 'Q') {
      for (
        var i = t.params.paddingTop + t.params.verlegeabstand;
        i < h + t.params.paddingTop;
        i += t.params.verlegeabstand
      ) {
        lines.push(t.canvas.path('M' + t.params.paddingLeft + ',' + i + 'h' + w).attr({ stroke: '#dbdbdb' }));
        lines.push(
          t.canvas.path('M' + t.params.paddingLeft + ',' + (i + 1).toString() + 'h' + w).attr({ stroke: '#fff' })
        );
      }
    } else {
      for (
        var i = t.params.paddingLeft + t.params.verlegeabstand;
        i < w + t.params.paddingLeft;
        i += t.params.verlegeabstand
      ) {
        lines.push(t.canvas.path('M' + i + ',' + t.params.paddingTop + 'v' + h).attr({ stroke: '#dbdbdb' }));
        lines.push(
          t.canvas.path('M' + (i + 1).toString() + ',' + t.params.paddingTop + 'v' + h).attr({ stroke: '#fff' })
        );
      }
    }
    return lines;
  },

  drawRectangleMeasurements: function(w1, h1, rw1, rh1) {
    var t = this;
    var measurements = [];
    /*var text = t.canvas.text(0, 0, Globalize.format( rw1, "n") + " m" );
		text.translate((t.params.paddingLeft+w1 - text.getBBox().width)*0.5 + 15, (t.params.paddingTop - text.getBBox().height) - 15 );
		measurements.push( text );
		text = t.canvas.text(0, 0, Globalize.format( rh1, "n") + " m" );
		text.translate((t.params.paddingLeft+w1 - text.getBBox().width) + 30, (t.params.paddingTop + h1 - text.getBBox().height)*0.5 + 10 );
		measurements.push( text );*/

    measurements.push(
      t.canvas.text(t.ccx(t.params.paddingLeft + w1 * 0.5), t.params.paddingTop - 15, Globalize.format(rw1, 'n') + ' m')
    );
    measurements.push(
      t.canvas.text(
        t.ccx(t.params.paddingLeft + w1 + 30),
        t.params.paddingTop + h1 * 0.5,
        Globalize.format(rh1, 'n') + ' m'
      )
    );

    return measurements;
  },

  drawMarker: function(x, y, laenge, rotation) {
    var t = this;
    var rott_off = Raphael.type == 'VML' ? 1.0 : 0;
    return [
      t.canvas
        .path('M' + (x - 2) + ',' + (y - 2) + 'l-4,-4v' + (laenge + 12) + 'l4,-4Z')
        .rotate(t.params.deckwinkel, 175, 175)
        .rotate(rotation, x - rott_off, y - rott_off)
        .attr({ stroke: '#be0000', fill: '#be0000', 'stroke-width': 1, cursor: 'pointer' }),
      t.canvas
        .path('M' + (x + 2) + ',' + (y + 2) + 'l4,4v' + (laenge - 12) + 'l-4,4Z')
        .rotate(t.params.deckwinkel, 175, 175)
        .rotate(rotation, x - rott_off, y - rott_off)
        .attr({ stroke: '#be0000', fill: '#be0000', 'stroke-width': 1, cursor: 'pointer' }),
    ];
  },

  drawHoverMarker: function(x, y, laenge, rotation) {
    var t = this;
    var rott_off = Raphael.type == 'VML' ? 1.0 : 0;
    return [
      t.canvas
        .path('M' + (x - 2) + ',' + (y - 2) + 'l-4,-4v' + (laenge + 12) + 'l4,-4Z')
        .rotate(t.params.deckwinkel, 175, 175)
        .rotate(rotation, x - rott_off, y - rott_off)
        .attr({ stroke: '#999999', fill: '#999999', 'stroke-width': 1, cursor: 'pointer' }),
      t.canvas
        .path('M' + (x + 2) + ',' + (y + 2) + 'l4,4v' + (laenge - 12) + 'l-4,4Z')
        .rotate(t.params.deckwinkel, 175, 175)
        .rotate(rotation, x - rott_off, y - rott_off)
        .attr({ stroke: '#999999', fill: '#999999', 'stroke-width': 1, cursor: 'pointer' }),
    ];
  },

  drawConcaveMarker: function(x, y, laenge, direction) {
    var t = this;
    return [
      t.canvas
        .path('M' + (x + 2).toString() + ',' + (y - 2).toString() + 'l4,-4' + direction + laenge.toString() + 'l-4,4Z')
        .rotate(t.params.deckwinkel, 175, 175)
        .attr({ stroke: '#be0000', fill: '#be0000', 'stroke-width': 1, cursor: 'pointer' }),
      t.canvas
        .path('M' + (x - 2).toString() + ',' + (y + 2).toString() + 'l-4,4' + direction + laenge.toString() + 'l4,-4Z')
        .rotate(t.params.deckwinkel, 175, 175)
        .attr({ stroke: '#be0000', fill: '#be0000', 'stroke-width': 1, cursor: 'pointer' }),
    ];
  },

  undrawMarker: function(position) {
    var t = this;
    for (var marker in t.markers[position]) {
      t.markers[position][marker].remove();
      delete t.markers[position][marker];
    }
    delete t.markers[position];
  },

  undrawHoverMarker: function(position) {
    var t = this;
    for (var hoverMarker in t.hoverMarkers[position]) {
      t.hoverMarkers[position][hoverMarker].remove();
      delete t.hoverMarkers[position][hoverMarker];
    }
    delete t.hoverMarkers[position];
  },

  addQuantities: function(position, verlegerichtung, laenge, anzzeilen) {
    var t = this;
    switch (position) {
      case 'links':
      case 'rechts':
      case 'mitte_vertikal':
        if (verlegerichtung === 'Q') {
          t.kappen += anzzeilen;
        } else {
          t.leisten += laenge;
        }
        t.alleleisten += laenge;
        break;
      case 'oben':
      case 'unten':
      case 'mitte_horizontal':
        if (verlegerichtung === 'Q') {
          t.leisten += laenge;
        } else {
          t.kappen += anzzeilen;
        }
        t.alleleisten += laenge;
        break;
    }
    t.leisten = Math.max(t.leisten, 0);
    t.kappen = Math.max(t.kappen, 0);

    jQuery('input[name=kappen]').val(t.kappen);
    jQuery('input[name=leisten]').val(t.leisten.toFixed(2));
    jQuery('input[name=alleleisten]').val(t.alleleisten.toFixed(2));
    jQuery('input[name=leisten],input[name=kappen]').change();
    t.ausgewaelteraender[position] = true;
    t.updateChosenSides();
  },

  removeQuantities: function(position, verlegerichtung, laenge, anzzeilen) {
    var t = this;
    switch (position) {
      case 'links':
      case 'rechts':
      case 'mitte_vertikal':
        if (verlegerichtung === 'Q') {
          t.kappen -= anzzeilen;
        } else {
          t.leisten -= laenge;
        }
        t.alleleisten -= laenge;
        break;
      case 'oben':
      case 'unten':
      case 'mitte_horizontal':
        if (verlegerichtung === 'Q') {
          t.leisten -= laenge;
        } else {
          t.kappen -= anzzeilen;
        }
        t.alleleisten -= laenge;
        break;
    }
    jQuery('input[name=kappen]').val(t.kappen);
    jQuery('input[name=leisten]').val(t.leisten.toFixed(2));
    jQuery('input[name=alleleisten]').val(t.alleleisten.toFixed(2));
    jQuery('input[name=leisten],input[name=kappen]').change();
    delete t.ausgewaelteraender[position];
    t.updateChosenSides();
  },

  updateChosenSides: function() {
    var t = this;
    var raender = [];
    for (var rand in t.ausgewaelteraender) {
      raender.push(rand);
    }
    jQuery('input[name=ausgewaelteraender]').val(raender.join(','));
  },

  //// LFORM

  initLForm: function() {
    var t = this;
    t.canvas.setStart();
    t.form = t.drawLForm(t.params.w1, t.params.h1, t.params.w2, t.params.h2);
    t.lines = t.drawLFormLines(t.params.w1, t.params.h1, t.params.w2, t.params.h2, t.params.verlegerichtung);
    t.interactives = t.drawLFormInteractives(t.params.w1, t.params.h1, t.params.w2, t.params.h2);
    t.measurements = t.drawLFormMeasurements(
      t.params.w1,
      t.params.h1,
      t.params.w2,
      t.params.h2,
      t.params.rw1,
      t.params.rh1,
      t.params.rw2,
      t.params.rh2
    );

    t.canvas.setFinish().rotate(t.params.deckwinkel, 175, 175);

    t.drawLFormSavedMarkers();

    t.rotateLFormMeasurements();
  },

  drawLFormSavedMarkers: function() {
    var t = this;
    for (var rand in t.ausgewaelteraender) {
      switch (rand) {
        case 'links':
          t.markers['links'] = t.drawMarker(t.params.paddingLeft, t.params.paddingTop, t.params.h1 + t.params.h2, 0);
          t.addQuantities(
            'links',
            t.params.verlegerichtung,
            t.params.rh1 + t.params.rh2,
            t.params.anzzeilen2 + t.params.anzzeilen1
          );
          break;
        case 'rechts':
          t.markers['rechts'] = t.drawMarker(
            t.params.paddingLeft + t.params.w1 + t.params.w2,
            t.params.paddingTop + t.params.h1 + t.params.h2,
            t.params.h2,
            180
          );
          t.addQuantities('rechts', t.params.verlegerichtung, t.params.rh2, t.params.anzzeilen2);
          break;
        case 'mitte_vertikal':
          t.markers['mitte_vertikal'] = t.drawConcaveMarker(
            t.params.paddingLeft + t.params.w1,
            t.params.paddingTop,
            t.params.h1,
            'v'
          );
          t.addQuantities('mitte_vertikal', t.params.verlegerichtung, t.params.rh1, t.params.anzzeilen1);
          break;
        case 'oben':
          t.markers['oben'] = t.drawMarker(t.params.paddingLeft + t.params.w1, t.params.paddingTop, t.params.w1, 90);
          t.addQuantities('oben', t.params.verlegerichtung, t.params.rw1, t.params.anzzeilen2);
          break;
        case 'unten':
          t.markers['unten'] = t.drawMarker(
            t.params.paddingLeft,
            t.params.paddingTop + t.params.h1 + t.params.h2,
            t.params.w1 + t.params.w2,
            270
          );
          t.addQuantities(
            'unten',
            t.params.verlegerichtung,
            t.params.rw1 + t.params.rw2,
            t.params.anzzeilen2 + t.params.anzzeilen1
          );
          break;
        case 'mitte_horizontal':
          t.markers['mitte_horizontal'] = t.drawConcaveMarker(
            t.params.paddingLeft + t.params.w1,
            t.params.paddingTop + t.params.h1,
            t.params.w2,
            'h'
          );
          t.addQuantities('mitte_horizontal', t.params.verlegerichtung, t.params.rw2, t.params.anzzeilen1);
          break;
      }
    }
    for (var i in t.interactives) {
      t.interactives[i].toFront();
    }
  },

  drawLForm: function(w1, h1, w2, h2, deckwinkel) {
    var t = this;
    return t.canvas
      .path(
        'M' +
          t.params.paddingLeft +
          ',' +
          t.params.paddingTop +
          'v' +
          (h1 + h2) +
          'h' +
          (w1 + w2) +
          'v-' +
          h2 +
          'h-' +
          w2 +
          'v-' +
          h1 +
          'Z'
      )
      .attr({ stroke: '#bdbcba', fill: '#ebebea', 'stroke-width': 1 });
  },

  drawLFormInteractives: function(w1, h1, w2, h2) {
    var t = this;
    var interactives = [];

    //// Oben
    interactives.push(
      t.canvas
        .rect(
          t.params.paddingLeft + t.params.interaktiv2,
          t.params.paddingTop - t.params.interaktiv2,
          w1 - t.params.interaktiv,
          t.params.interaktiv
        )
        .attr({ stroke: '#bdbcba', fill: '#ebebea', 'stroke-width': 1, opacity: 0, cursor: 'pointer' })
        .click(function() {
          if (typeof t.markers['oben'] !== 'undefined') {
            t.undrawMarker('oben');
            t.removeQuantities('oben', t.params.verlegerichtung, t.params.rw1, t.params.anzzeilen2);
          } else {
            t.markers['oben'] = t.drawMarker(t.params.paddingLeft + t.params.w1, t.params.paddingTop, t.params.w1, 90);
            t.addQuantities('oben', t.params.verlegerichtung, t.params.rw1, t.params.anzzeilen2);
          }
          for (var i in interactives) {
            interactives[i].toFront();
          }
        })
      // .hover(
      // 	function() {
      // 		if (!(/MSIE\s([\d.]+)/.test(navigator.userAgent))) {
      // 			if ( typeof t.hoverMarkers["oben"] == "undefined" && typeof t.markers["oben"] == "undefined" ) {
      // 				t.hoverMarkers["oben"] = t.drawHoverMarker( t.params.paddingLeft + t.params.w1, t.params.paddingTop, t.params.w1, 90 );
      // 			}
      // 			for (var i in interactives ) {
      // 				interactives[i].toFront();
      // 			}
      // 		}
      // 	},
      // 	function() {
      // 		if (!(/MSIE\s([\d.]+)/.test(navigator.userAgent))) {
      // 			if ( typeof  t.hoverMarkers["oben"] !== "undefined" ) {
      // 				t.undrawHoverMarker( "oben" );
      // 			}
      // 			for (var i in interactives ) {
      // 				interactives[i].toFront();
      // 			}
      // 		}
      // 	}
      // )
    );

    /// unten
    interactives.push(
      t.canvas
        .rect(
          t.params.paddingLeft + t.params.interaktiv2,
          t.params.paddingTop + h1 + h2 - t.params.interaktiv2,
          w1 + w2 - t.params.interaktiv,
          t.params.interaktiv
        )
        .attr({ stroke: '#bdbcba', fill: '#ebebea', 'stroke-width': 1, opacity: 0, cursor: 'pointer' })
        .click(function() {
          if (typeof t.markers['unten'] !== 'undefined') {
            t.undrawMarker('unten');
            t.removeQuantities(
              'unten',
              t.params.verlegerichtung,
              t.params.rw1 + t.params.rw2,
              t.params.anzzeilen2 + t.params.anzzeilen1
            );
          } else {
            t.markers['unten'] = t.drawMarker(
              t.params.paddingLeft,
              t.params.paddingTop + t.params.h1 + t.params.h2,
              t.params.w1 + t.params.w2,
              270
            );
            t.addQuantities(
              'unten',
              t.params.verlegerichtung,
              t.params.rw1 + t.params.rw2,
              t.params.anzzeilen2 + t.params.anzzeilen1
            );
          }
          for (var i in interactives) {
            interactives[i].toFront();
          }
        })
    );
    /// links
    interactives.push(
      t.canvas
        .rect(
          t.params.paddingLeft - t.params.interaktiv2,
          t.params.paddingTop + t.params.interaktiv2,
          t.params.interaktiv,
          h1 + h2 - t.params.interaktiv
        )
        .attr({ stroke: '#bdbcba', fill: '#ebebea', 'stroke-width': 1, opacity: 0, cursor: 'pointer' })
        .click(function() {
          if (typeof t.markers['links'] !== 'undefined') {
            t.undrawMarker('links');
            t.removeQuantities(
              'links',
              t.params.verlegerichtung,
              t.params.rh1 + t.params.rh2,
              t.params.anzzeilen2 + t.params.anzzeilen1
            );
          } else {
            t.markers['links'] = t.drawMarker(t.params.paddingLeft, t.params.paddingTop, t.params.h1 + t.params.h2, 0);
            t.addQuantities(
              'links',
              t.params.verlegerichtung,
              t.params.rh1 + t.params.rh2,
              t.params.anzzeilen2 + t.params.anzzeilen1
            );
          }
          for (var i in interactives) {
            interactives[i].toFront();
          }
        })
    );
    /// rechts
    interactives.push(
      t.canvas
        .rect(
          t.params.paddingLeft + w1 + w2 - t.params.interaktiv2,
          t.params.paddingTop + h1 + t.params.interaktiv2,
          t.params.interaktiv,
          h2 - t.params.interaktiv
        )
        .attr({ stroke: '#bdbcba', fill: '#ebebea', 'stroke-width': 1, opacity: 0, cursor: 'pointer' })
        .click(function() {
          if (typeof t.markers['rechts'] !== 'undefined') {
            t.undrawMarker('rechts');
            t.removeQuantities('rechts', t.params.verlegerichtung, t.params.rh2, t.params.anzzeilen2);
          } else {
            t.markers['rechts'] = t.drawMarker(
              t.params.paddingLeft + t.params.w1 + t.params.w2,
              t.params.paddingTop + t.params.h1 + t.params.h2,
              t.params.h2,
              180
            );
            t.addQuantities('rechts', t.params.verlegerichtung, t.params.rh2, t.params.anzzeilen2);
          }
          for (var i in interactives) {
            interactives[i].toFront();
          }
        })
    );
    /// mitte vertikal
    interactives.push(
      t.canvas
        .rect(
          t.params.paddingLeft + w1 - t.params.interaktiv2,
          t.params.paddingTop + t.params.interaktiv2,
          t.params.interaktiv,
          h1 - t.params.interaktiv
        )
        .attr({ stroke: '#bdbcba', fill: '#ebebea', 'stroke-width': 1, opacity: 0, cursor: 'pointer' })
        .click(function() {
          if (typeof t.markers['mitte_vertikal'] !== 'undefined') {
            t.undrawMarker('mitte_vertikal');
            t.removeQuantities('mitte_vertikal', t.params.verlegerichtung, t.params.rh1, t.params.anzzeilen1);
          } else {
            t.markers['mitte_vertikal'] = t.drawConcaveMarker(
              t.params.paddingLeft + t.params.w1,
              t.params.paddingTop,
              t.params.h1,
              'v'
            );
            t.addQuantities('mitte_vertikal', t.params.verlegerichtung, t.params.rh1, t.params.anzzeilen1);
          }
          for (var i in interactives) {
            interactives[i].toFront();
          }
        })
    );
    /// mitte horizontal
    interactives.push(
      t.canvas
        .rect(
          t.params.paddingLeft + w1 + t.params.interaktiv2,
          t.params.paddingTop + h1 - t.params.interaktiv2,
          w2 - t.params.interaktiv,
          t.params.interaktiv
        )
        .attr({ stroke: '#bdbcba', fill: '#ebebea', 'stroke-width': 1, opacity: 0, cursor: 'pointer' })
        .click(function() {
          if (typeof t.markers['mitte_horizontal'] !== 'undefined') {
            t.undrawMarker('mitte_horizontal');
            t.removeQuantities('mitte_horizontal', t.params.verlegerichtung, t.params.rw1, t.params.anzzeilen1);
          } else {
            t.markers['mitte_horizontal'] = t.drawConcaveMarker(
              t.params.paddingLeft + t.params.w1,
              t.params.paddingTop + t.params.h1,
              t.params.w2,
              'h'
            );
            t.addQuantities('mitte_horizontal', t.params.verlegerichtung, t.params.rw2, t.params.anzzeilen1);
          }
          for (var i in interactives) {
            interactives[i].toFront();
          }
        })
    );

    return interactives;
  },

  drawLFormLines: function(w1, h1, w2, h2, verlegerichtung) {
    var t = this;
    var lines = [];
    if (verlegerichtung === 'Q') {
      var i = t.params.paddingTop + t.params.verlegeabstand;
      for (; i < h1 + t.params.paddingTop; i += t.params.verlegeabstand) {
        lines.push(t.canvas.path('M' + t.params.paddingLeft + ',' + i + 'h' + w1).attr({ stroke: '#dbdbdb' }));
        lines.push(
          t.canvas.path('M' + t.params.paddingLeft + ',' + (i + 1).toString() + 'h' + w1).attr({ stroke: '#fff' })
        );
      }
      for (; i < h1 + h2 + t.params.paddingTop; i += t.params.verlegeabstand) {
        lines.push(
          t.canvas.path('M' + t.params.paddingLeft + ',' + i + 'h' + (w1 + w2).toString()).attr({ stroke: '#dbdbdb' })
        );
        lines.push(
          t.canvas
            .path('M' + t.params.paddingLeft + ',' + (i + 1).toString() + 'h' + +(w1 + w2).toString())
            .attr({ stroke: '#fff' })
        );
      }
    } else {
      var i = t.params.paddingLeft + t.params.verlegeabstand;
      for (; i < w1 + t.params.paddingLeft; i += t.params.verlegeabstand) {
        lines.push(
          t.canvas.path('M' + i + ',' + t.params.paddingTop + 'v' + (h1 + h2).toString()).attr({ stroke: '#dbdbdb' })
        );
        lines.push(
          t.canvas
            .path('M' + (i + 1).toString() + ',' + t.params.paddingTop + 'v' + (h1 + h2).toString())
            .attr({ stroke: '#fff' })
        );
      }
      for (; i < w1 + w2 + t.params.paddingLeft; i += t.params.verlegeabstand) {
        lines.push(
          t.canvas.path('M' + i + ',' + (t.params.paddingTop + h1).toString() + 'v' + h2).attr({ stroke: '#dbdbdb' })
        );
        lines.push(
          t.canvas
            .path('M' + (i + 1).toString() + ',' + (t.params.paddingTop + h1).toString() + 'v' + h2)
            .attr({ stroke: '#fff' })
        );
      }
    }
    return lines;
  },

  drawLFormMeasurements: function(w1, h1, w2, h2, rw1, rh1, rw2, rh2) {
    var t = this;
    var measurements = [];

    var size = 10;

    //if ( !t.params.deckwinkel ) {
    var x, y;
    x = t.ccx(t.params.paddingLeft + w1 * 0.5);
    y = t.ccy(t.params.paddingTop - 15);
    measurements.push(t.canvas.text(x, y, Globalize.format(rw1, 'n') + ' m'));
    measurements.push(
      t.canvas.text(
        t.ccx(t.params.paddingLeft + w1 + 30),
        t.ccy(t.params.paddingTop + h1 * 0.5),
        Globalize.format(rh1, 'n') + ' m'
      )
    );

    measurements.push(
      t.canvas.text(
        t.ccx(t.params.paddingLeft + w1 + w2 * 0.5),
        t.ccy(t.params.paddingTop + h1 - 15),
        Globalize.format(rw2, 'n') + ' m'
      )
    );
    measurements.push(
      t.canvas.text(
        t.ccx(t.params.paddingLeft + w1 + w2 + 30),
        t.ccy(t.params.paddingTop + h1 + h2 * 0.5),
        Globalize.format(rh2, 'n') + ' m'
      )
    );
    //}

    return measurements;
  },

  rotateLFormMeasurements: function() {
    var t = this;
    for (var m in t.measurements) {
      var txt = t.measurements[m];
      t.measurements[m].rotate(-t.params.deckwinkel, txt.attr('x') - 10, txt.attr('y'));
    }
  },

  ccx: function(cx) {
    var offsetx = 0;
    return offsetx + cx;
  },
  ccy: function(cy) {
    var offsety = 0;
    var coefy = 1;
    return (offsety + cy) * coefy;
  },
};
